/**
 * Formats a date with weekday abbreviation
 * Example: "Mo, 1.9.2025"
 */
export const formatDateWithWeekday = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const weekdayAbbreviations = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  const weekday = weekdayAbbreviations[dateObj.getDay()];

  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();

  return `${weekday}, ${day}.${month}.${year}`;
};